<script>
  import { Slider, isDev } from '$client';
  import Item from './Item.svelte';
  export let data = [];
  export let type = 'white';
  export let header = 'Партнеры';
  export let buttons = true;
  export let url = '';
  const pool = [
    'https://thumbs.gfycat.com/AngelicConcreteHypsilophodon-size_restricted.gif',
    'https://thumbs.gfycat.com/HeftyInferiorIndianabat-size_restricted.gif',
    'https://gifdb.com/images/high/programming-angry-punching-keyboard-fw45yh2e39g24ylb.gif',
    'https://i.gifer.com/7SvX.gif',
  ];

  const media = [
    { size: 99999, gap: 40, count: 5 },
    { size: 1500, gap: 40, count: 4 },
    { size: 1199.98, gap: 20, count: 3 },
    { size: 991.98, gap: 15, count: 3 },
    { size: 767.98, gap: 10, count: 3 },
  ];

  const createPartner = () => ({ attributes: { url: pool[Math.ceil(Math.random() * pool.length - 1)] } });
  $: if (!data.length && isDev()) data = new Array(10).fill({}).map(createPartner);
</script>

<Slider
  {url}
  {buttons}
  attributes={{ 'data-class': 'partners-slider' }}
  {header}
  {type}
  component={Item}
  {data}
  {media} />
